import {Component, Input, OnInit} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, FormArray,Validators, FormControl} from '@angular/forms';
import {SpinnerService} from '../../shared/services/spinner.service';
import {ToastNotificationService} from '../../shared/services/toast-notify.service';
import { environment } from 'src/environments/environment';
import { FeeStudent } from 'src/app/models/fee-student.model';
import { FeeService } from './services/fee.service';
import { PaymentHistory } from 'src/app/models/payment-history.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-fee',
  templateUrl: './payment.history.component.html',
  styleUrls: ['./fee.component.scss'],  
})
export class PaymentHistoryComponent implements OnInit {

  @Input() paymentHistory: PaymentHistory[];
  @Input() modalRef: NgbModalRef;
  
  countryList: any[];
  routeArray: any[];
  dateTimeFormat: string;

  constructor(private formBuilder: FormBuilder,
                  private route: ActivatedRoute,
                  private router: Router,
                  private spinnerService: SpinnerService,
                  private toastNotifyService: ToastNotificationService,private feeService: FeeService
              ) {
    }
  
    ngOnInit() {      
      console.log('****ngOnInit- PaymentHistoryComponent: ');
      this.countryList = environment.countryList;
      this.dateTimeFormat = environment.dtFormatDefault
      //this.routeArray = JSON.parse(this.paymentHistory);
      console.log('paymentHistory>>>>>> ',JSON.stringify(this.paymentHistory))     
    }
    
    downloadReceipt(paymentHistId: number): void {
      console.log('-------downloadReceipt--------:',paymentHistId)
      this.feeService.renderReceiptPdf(paymentHistId)
        .subscribe({
          next:(response: any) => {  
            var file = new Blob([response], {type: 'application/pdf'}); //new window.Blob
              var fileURL = URL.createObjectURL(file); //window.URL
              window.open(fileURL, '_blank');
          },
          error: (error: HttpErrorResponse) => {
            console.error('There was an error!', error);//${error.status} - ${error.message}`;
            // You can perform more specific error handling here,
            setTimeout(() => {
              this.spinnerService.hideSpinner();
            }, 200);
          },
          complete: () => {
            console.log('----------Request completed-----------');
          }
        });
    }
    generateReceipt(paymentHistId: number): void {// re-generates if failed earlier
      console.log('-------generateReceipt--------:',paymentHistId)
      this.spinnerService.showSpinner();
      this.feeService.generateReceipt(paymentHistId).subscribe(
        res => {
          if(environment.SUCCESS == res.status){
            this.toastNotifyService.showSuccess(res.message, "Notification");
          }else if(environment.FAILURE == res.status){
            this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 10000);
          }
          this.spinnerService.hideSpinner();
          //this.router.navigate(['/user/process']);
          this.modalRef.close();
        },
        error => {
          console.log(error);   
          setTimeout(() => {
            this.spinnerService.hideSpinner();
          }, 200);       
        },
        );
    }

    getSelectedCountry(value: string){}

    /** Close modal */
    close() {
      console.log('****close edit-modal*****');
      this.modalRef.close();
    }
    /** Dismiss dialog */
    cancel() {
      console.log('****cancel-dismiss modal');
      this.modalRef.dismiss();
    }
}
